import React from "react";
import { Source, Layer } from "react-map-gl";

const notShownDataSource = {
  id: "not-shown/data-source",
  type: "geojson",
  data: {
    type: "FeatureCollection",
    features: [],
  },
}

const newRefLayer = (type, id) => {
  return {
    id: id,
    source: notShownDataSource.id,
    type: type,
    layout: {
      visibility: "none",
    },
  }
}

const notShownBaseLayer = newRefLayer(
  "background",
  "not-shown/ref-layer-to-insert-before/base",
)

const notShownSelectRegionLayer = newRefLayer(
  "background",
  "not-shown/ref-layer-to-insert-before/selected-region",
)

const notShownPolyLayer = newRefLayer(
  "fill",
  "not-shown/ref-layer-to-insert-before/poly",
)

const notShownPoly2Layer = newRefLayer(
  "fill",
  "not-shown/ref-layer-to-insert-before/poly2",
)

const notShownPointLayer = newRefLayer(
  "circle",
  "not-shown/ref-layer-to-insert-before/point",
)

export default function ReferenceLayers() {
  return (
    <>
      <Source key={notShownDataSource.id} {...notShownDataSource}>
        <Layer key={notShownBaseLayer.id} {...notShownBaseLayer} />
        <Layer key={notShownSelectRegionLayer.id} {...notShownSelectRegionLayer} />
        <Layer key={notShownPolyLayer.id} {...notShownPolyLayer} />
        <Layer key={notShownPoly2Layer.id} {...notShownPoly2Layer} />
        <Layer key={notShownPointLayer.id} {...notShownPointLayer} />
      </Source>
    </>
  );
}